import styled from 'styled-components';

export const MoveToKitWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 4rem;
    .content {
        color: #fff;
        font-weight: bold;
        font-size: 15px;
    }

    .master-admin-img {
        width: 150px;
        margin: 30px 0px;
    }

    .Trade-wrapper {
        .ant-btn {
            width: 300px;
            background-color: #288500;
            color: #FFFFFF;
        }
    }
    @media (max-width: 960px) {
        margin: 1rem;
    }
`;